// extracted by mini-css-extract-plugin
export default {"portTable":"portfolioAfter_portTable__20Bsl","minus":"portfolioAfter_minus__yWg+g"};